import { createActionCreator } from '../../utils/helpers';

import { dueActivitiesCount } from './types';

export const requestDueActivitiesCount = createActionCreator(dueActivitiesCount.request);
export const requestDueActivitiesCountSuccess = createActionCreator(
  dueActivitiesCount.success,
  'response',
);
export const requestDueActivitiesCountFailure = createActionCreator(
  dueActivitiesCount.failure,
  'error',
);
